import { render, staticRenderFns } from "./RegisterActive.vue?vue&type=template&id=c9c6bdde&"
import script from "./RegisterActive.vue?vue&type=script&lang=js&"
export * from "./RegisterActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports